import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  standalone: false,
  name: 'serviceTime'
})
export class ServiceTimePipe implements PipeTransform {

  constructor(
    @Inject(TranslateService) private translate: TranslateService
  ) {}

  transform(valueMs: number | null | undefined): string {
    if (valueMs == null || isNaN(Number(valueMs))) return '—';

    const totalMinutes = Math.floor(Math.max(0, valueMs) / 60000);

    if (totalMinutes <= 59) {
      return this.translate.instant('X_SERVICE_TIME_MIN_ONLY', {
        minutes: totalMinutes
      });
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return this.translate.instant('X_SERVICE_TIME', {
      hours,
      minutes
    });
  }
}
